/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-22 02:34:10
 * @FilePath: /zeelool-nextjs/src/components/Responsive/ResponsiveProvider.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import appCommunicationManager, {
  EAppCommunicationFuncName,
} from '@/utils/app-communication-manager';
import { EPlatform } from '@/utils/enums/platform-enum';
import { createContext, useEffect, useState } from 'react';

interface ResponsiveContextType {
  deviceType: EPlatform;
  iframeHeaderHeight?: number;
  setIFrameHeaderHeight?: (height: number) => void;
}

export const ResponsiveContext = createContext<ResponsiveContextType>({
  deviceType: EPlatform.WEB, // 确保默认值是有效的 EPlatform 类型
  iframeHeaderHeight: 0,
  setIFrameHeaderHeight: () => {},
});

export default function ResponsiveProvider({
  children,
  deviceType,
}: {
  children: React.ReactNode;
  deviceType: EPlatform;
}) {
  const [iframeHeaderHeight, setIFrameHeaderHeight] = useState(0);
  useEffect(() => {
    // 注册App全局监听和事件转发
    if (deviceType === EPlatform.ANDROID || deviceType === EPlatform.IOS) {
      // 注册App收藏数据监听
      appCommunicationManager.registerListener(
        EAppCommunicationFuncName.APP_WISH_DATA,
        (data: any) => {
          const appWishDataEvent = new CustomEvent('appWishData', {
            detail: data,
          });
          window.dispatchEvent(appWishDataEvent);
        },
      );
      // 注册App页面可见性监听
      appCommunicationManager.registerListener(
        EAppCommunicationFuncName.WEB_VIEW_VISIBILITY,
        (data: any) => {
          const webViewVisibilityEvent = new CustomEvent('appWebViewVisibility', {
            detail: {
              isVisible: data,
            },
          });
          window.dispatchEvent(webViewVisibilityEvent);
        },
      );
      // 注册App页面浏览和离开监听
      appCommunicationManager.registerAppEnterLeaveListener();
    }
  }, []);
  return (
    <ResponsiveContext.Provider value={{ deviceType, iframeHeaderHeight, setIFrameHeaderHeight }}>
      {children}
    </ResponsiveContext.Provider>
  );
}
